import { t } from 'i18next';
import z from 'zod';
import { OnboardingFormFields } from '@Types/index.ts';
import { ControlledTextInput } from './ControlledInputs';

interface ApartmentInputProps {
  disabled?: boolean;
  tabIndex?: number;
}

export const ApartmentInput = ({ disabled = false, tabIndex }: ApartmentInputProps) => {
  return (
    <ControlledTextInput
      name={OnboardingFormFields.APARTMENT}
      title={t('pages.businessAddress.fields.apt')}
      id={OnboardingFormFields.APARTMENT}
      disabled={disabled}
      isPublic
      tabindex={tabIndex}
    />
  );
};

export const ApartmentSchema = z.object({
  [OnboardingFormFields.APARTMENT]: z.string().optional(),
});
